export default __webpack_public_path__ + "static/media/SXMMediaLogo.6cdec0ab.png";